"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EProductFileTypeTrads = void 0;
exports.EProductFileTypeTrads = {
    annual_report: "Rapport annuel",
    key_information: "Document d'information clé",
    plaquette: "Plaquette",
    rib: "RIB",
    status: "Statuts",
    trimestrial_report: "Rapport trimestriel",
    note_information: "Note d'information",
    target_market: "Marché cible",
    other: "Autre",
};
